import { useState } from "react";
import { documentService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useManageDocumentCategoryViewModel = () => {
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedDocumentCategory, setSelectedDocumentCategory] = useState({});
  const [documentCategories, setDocumentCategories] = useState([]);

  const stateManager = useComponentState();

  const getAllDocumentCategories = () => {
    stateManager.run(async () => {
      const response = await documentService.documentCategories.getAll();

      if (response.status === HTTP_STATUSES.OK) {
        setDocumentCategories(
          response.data.map((documentCategory, index) => ({
            ...documentCategory,
            index,
          }))
        );
      }
    });
  };

  const toggleAddModal = () => {
    setIsAddModalVisible((prev) => !prev);
  };

  const createDocumentCategory = (data) => {
    stateManager.run(async () => {
      const response = await documentService.documentCategories.create({
        data,
      });
      if (response.status === HTTP_STATUSES.OK) {
        getAllDocumentCategories();
      }
    });
  };

  const updateDocumentCategory = (data) => {
    stateManager.run(async () => {
      const response = await documentService.documentCategories.update({
        data,
      });
      if (response.status === HTTP_STATUSES.OK) {
        getAllDocumentCategories();
      }
    });
  };

  const deleteDocumentCategory = ({ id, modifiedOn }) => {
    stateManager.run(async () => {
      const response = await documentService.documentCategories.delete({
        id,
        modifiedOn,
      });
      if (response.status === HTTP_STATUSES.OK) {
        getAllDocumentCategories();
      }
    });
  };

  const closeDeleteModal = () => {
    setIsDeleteModalVisible(false);
  };

  const openDeleteModal = (documentCategory) => () => {
    setIsDeleteModalVisible(true);
    setSelectedDocumentCategory(documentCategory);
  };

  const onDelete = () => {};

  return {
    documentCategories,
    isAddModalVisible,
    isLoading: stateManager.isBusy(),
    isDeleteModalVisible,
    selectedDocumentCategory,
    getAllDocumentCategories,
    toggleAddModal,
    openDeleteModal,
    onDelete,
    closeDeleteModal,
    createDocumentCategory,
    deleteDocumentCategory,
    updateDocumentCategory,
  };
};
